var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardHeader',[_vm._t("header",function(){return [_c('CIcon',{attrs:{"name":"cil-wallet"}}),_vm._v(" "+_vm._s(_vm.caption)+" "),_c('div',{staticClass:"card-header-actions"})]})],2),_c('CCardBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }